// Components==============
import indexGroowtorial from 'actions/groowtorial/index';
import indexFavorite from 'actions/favorite/index';
import Layout from 'components/Layout/Layout';
import Container from 'components/UI/Container/Container';
import GroowTorialCard from 'components/UI/GroowTorialCard/GroowTorialCard';
import Title from 'components/UI/Title/Title';
import { useRedux } from 'hooks/useRedux';
import { useReduxAction } from 'hooks/useReduxAction';
import React, { useEffect } from 'react';
import './Groowtorials.module.scss';
import Spinner from 'components/UI/Spinner/Spinner';
// =========================

export default function Groowtorials() {
  const dispatch = useReduxAction();

  useEffect(() => {
    dispatch(indexGroowtorial());
    dispatch(indexFavorite());
  }, []);

  const groowtorials = useRedux((state) =>
    state.groowtorial?.entities.allIds.map(
      (id) => state.groowtorial?.entities.byId[id]
    )
  );

  return (
    <Layout>
      {groowtorials?.length ? (
        <Container>
          <Title text="general.terms.groowtorials" loading={false} />
          <div styleName="wrapper">
            {groowtorials?.map((gt) => (
              <GroowTorialCard groowTorial={gt} key={gt?.id} />
            ))}
          </div>
        </Container>
      ) : (
        <Spinner fullPage />
      )}
    </Layout>
  );
}
